import React, { Component } from 'react';

class FeatureLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Dominar los fundamentos del control adaptativo',
                    text: 'Comprenderás las bases teóricas y prácticas del control adaptativo y su aplicación en sistemas dinámicos reales.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Aplicar redes neuronales recurrentes en el control',
                    text: 'Aprenderás a diseñar y entrenar redes recurrentes para resolver problemas complejos de predicción y control.'
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Implementar ejemplos prácticos en MATLAB',
                    text: 'Desarrollarás simulaciones paso a paso en MATLAB que te permitirán aplicar los conceptos en casos reales.'
                }
            ]            
        }
    }

    render() {
        return (
            <div className="topic-items">
            {
                    this.state.collLeft.map((data,i) => (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>
                    
                    ))
            }
            </div>
        );
    }

}

export default FeatureLeft;
